import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserRoles } from '../../enums/enums';
import { ProfileService } from '../../services/profile.service';
import { StorageService } from '../../services/storage.service';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Output() onShowSideBar: EventEmitter<any> = new EventEmitter<any>();
  showMenu: boolean = false;
  userRoles = UserRoles;
  constructor(
    private storageService: StorageService,
    private router: Router,
    public profileService: ProfileService
  ) {}

  ngOnInit(): void {}

  logout() {
    this.storageService.clearStorage();
    this.router.navigate(['/login']);
  }
  showSideBar() {
    this.onShowSideBar.emit();
  }
  toggleMenu() {
    this.showMenu = !this.showMenu;
  }
}
